<template>
  <div>
    <header>
            <div class="headerOne">
                   <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
                <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
                <span class="buss">联系方式</span>
            </div>
    </header>
    <div class="detail">
         <div class="nameOld">
                <span>公司名称</span>
                <span>
                上海卡逸客互联网科技有限公司
                </span>
            </div>
            <div class="site">
                <span>公司地址</span>
                <span>上海市徐家汇漕河泾新兴技术开发区桂平路680号创业中心大厦32号楼720室</span>
            </div>
            <div class="four">
                <span>联系电话</span>
                <span>021-80158000</span>
            </div>
    </div>
  </div>
</template>
<script>
    export default{
        data(){
            return{
                msg:"联系"
            }
        }
    }
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header{
    height:1.6rem;
    width: 100%;
    border-bottom: 1px solid rgba(48, 1, 1, 0.2);
    position: relative;
}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
  .detail{
      color: rgba(0,0,0, 0.5);
      font-size: 0.55rem;
      margin-left: 0.4rem;
      margin-top: 0.4rem
  }
  .detail div{
      margin-bottom: 0.6rem
  }
  .detail div span:nth-child(1){
     color: rgba(0,0,0, 0.9)
  }
  .four{
      margin-top: 2rem
  }
   .detail div span:nth-child(2){
     margin-left: 0.2rem;
     display: inline-block;
    height: 1rem;
    width: 7rem;
    vertical-align: top;
  }
  .detail div:nth-child(2) span:nth-child(2){
   display: inline-block;
   height: 1rem;
   width: 7rem;
   vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/change/relation.vue